module.exports = __webpack_public_path__ + "img/home-placeholder.2ec0b896.png";